function isIosWebview() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
            || (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document);
}

export default isIosWebview;
